module.exports = Promise.all([parcelRequire.load("aW7bM"), parcelRequire.load("ay1lM")]).then(() => parcelRequire('fDjXw'));